import { HistoryFiltersConfig } from '../../../configuration'

export const historyFiltersAttributesConfig: HistoryFiltersConfig['historyFiltersAttributes'] =
  [
    '50/22 kick',
    'Clearance',
    'Collected by the offense',
    'Dangerous play',
    'Dominant',
    'Forced into touch',
    'Forward pass',
    'Golden',
    'Intercepted',
    'Kick for touch',
    'Knock on',
    'Lead to try',
    'Lost',
    'Lost in Maul',
    'Lost in Ruck',
    'Lost in Scrum',
    'Offside',
    'Pass',
    'Restart kick',
    'Tap Kick',
    'Try saving',
    'Up and under',
    'Won',
  ]
